var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('router-view'),(_vm.$ability.can('read', 'SubclientAddPage'))?_c('b-row',{staticClass:"pr-4"},[_c('b-col',[_c('b-button',{staticClass:"p-button-primary float-right",on:{"click":_vm.goToAddSubclient}},[_vm._v(" "+_vm._s(_vm.$t("action.add.subclient"))+" ")])],1)],1):_vm._e(),_c('subclients-table')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }